import React from "react";
import {Paper, Skeleton, Typography} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import CustomerNoteCard from "../../../../../../components/app-specific/customer-note-card";
import {useTranslation} from "react-i18next";


const CustomerNotesGridView = ({
    notes,
    loading,
    toggleNoteIsPrivate,
    setNote,
    removeNote,
}) => {
    const {t} = useTranslation('views', {keyPrefix: 'app-specific.customer-notes'});

    return (
        <Paper elevation={0} sx={{padding: 2, margin: 0, borderRadius: 1}}>
            {
                loading &&
                <Grid container spacing={2} margin={0}>
                    {
                        Array.from({length: 8}).map((_, index) => (
                            <Grid key={index} xs={12} md={6} lg={4} xl={3}>
                                <Skeleton height={350} sx={{transform: 'none'}}/>
                            </Grid>
                        ))
                    }
                </Grid>
            }
            {
                !loading && notes?.length < 1 &&
                <Typography variant={'body2'} marginBlock={6} width={'100%'} textAlign={'center'}>
                    {t('emptyState')}
                </Typography>
            }
            {
                !loading && notes?.length > 0 &&
                <Grid container spacing={2} margin={0}>
                    {
                        notes.map((note) => (
                            <Grid className={'grid-view-note-card'} key={note.id} xs={12} md={6} lg={4} xl={3}>
                                <CustomerNoteCard
                                    note={note}
                                    toggleIsPrivate={toggleNoteIsPrivate}
                                    setNote={setNote}
                                    removeNote={removeNote}
                                    showSource
                                />
                            </Grid>
                        ))
                    }
                </Grid>
            }
        </Paper>
    );
};

export default CustomerNotesGridView;
